import React from 'react'
import FormattedTime from '@components/FormattedTime'

interface TimelineValue {
  s?: string | null // Start date
  e?: string | null // End date
}

interface TimelineRendererProps {
  value?: TimelineValue
  onClick?: () => void
}

const TimelineRenderer: React.FC<TimelineRendererProps> & { RENDERER_TYPE: string } = props => {
  const { value, onClick } = props

  const handleClick = (_e: React.MouseEvent<HTMLSpanElement>) => {
    if (onClick) {
      onClick()
    }
  }

  // Create something we can try to render by overlaying the value prop onto a default object
  const valueForRender: TimelineValue = {
    s: null,
    e: null,
    ...value,
  }

  const { s: startValue, e: endValue } = valueForRender
  let valueForTitle = startValue
  let endDateContent = null
  if (endValue) {
    endDateContent = (
      <>
        <span> - </span>
        <FormattedTime dateTime={endValue} />
      </>
    )
    valueForTitle = `${startValue} - ${endValue}`
  }

  return (
    <span
      className="content-renderer content-renderer--timeline timeline-renderer"
      title={valueForTitle || ''}
      onClick={handleClick}
    >
      {startValue && <FormattedTime dateTime={startValue} />}
      {endDateContent}
    </span>
  )
}

TimelineRenderer.RENDERER_TYPE = 'timeline'

export default TimelineRenderer
